import React, { useState, memo, useRef } from 'react';
import { Link, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { errToast, ValidatePassword } from '../../utils';
import { ResetPassword } from '@/api/endpoints'
import Field from '@/components/formFields/InputField/Field';
import AuthWrapper from './components/authWrapper';
import ActionBtn from '@/components/ActionBtn';


const ResetPass = () => {
    const [password, setPassword] = useState('')
    const [confirmPassword, setconfirmPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate();
    const {state} = useLocation()
   

    const resetPassword = (e) => {
        e?.preventDefault()

        if (!ValidatePassword(password?.value))
            return errToast("wrong-password")


        if (password?.value !== confirmPassword?.value)
            return errToast("password not matched")

        var ResetPasswordData = {
            otp: state?.code,
            email: state?.email,
            newPassword: password?.value,
            
        }

        setLoading(true)
        ResetPassword(ResetPasswordData).then(result => {
            setLoading(false)
                navigate('/auth/log-in', { state: { verifyMessage: "Password updated successfully" } })

        }).catch(() => {
            setLoading(false)
        })
    }

    return (

        <AuthWrapper>
            <Field className={'col-md-12'} lang='any' type="password" name="password" value={password} setValue={setPassword} label={t("password")} placeholder={t("password")} />

            <Field className='col-md-12' lang='any' type="password" name="confirmPassword" value={confirmPassword} setValue={setconfirmPassword} label={t("confirmNewPassword")} placeholder={t("confirmNewPassword")} />

            <ActionBtn isDisabled={loading} className={"login-btn"} onApply={e => resetPassword(e)} title={"Confirm"} />
            <div className='donot-have-account-container'>
                {t("backTo")} <Link to='/auth/log-in'> {" "}{t("login")}</Link>

            </div>
        </AuthWrapper>

    );
}

export default memo(ResetPass);

